<div class="login-main-wrapper business--info">
  <div
    class="recuvery-header--wrapper d-flex align-items-center justify-content-between"
  >
    <div class="left d-flex align-items-center flex--gap">
      <div class="logo-mobile">
        <img src="assets/images/img/recuver-logo-icon.svg" />
      </div>
      <div class="seprater border-right">
        <span>|</span>
      </div>
      <div class="right--content">
        <h6 class="fw-500 fs-16 mb-0">Setup your account</h6>
      </div>
    </div>
    <div class="right d-flex align-items-center flex--gap">
      <div class="help-content d-none">
        <h4 class="fw-400 fs-14 mb-0">Do you need help?</h4>
      </div>
      <div class="close-bth-circle cursor">
        <img (click)="logoutModal()" src="assets/images/img/logout--icon.png" />
      </div>
    </div>
  </div>
  <div class="inner-wrapper d-flex flex-column flex-lg-row">
    <div class="login-right-side flex-fill vh-100 overflow-lg-auto">
      <div class="h-100 w-100">
        <div
          class="right-content p-3 p-lg-0"
          *ngIf="selectedStep === step.BUSINESS_REGISTRATION"
        >
          <form action="" (submit)="submitPracticeInfo()">
            <ng-container [formGroup]="practiceInfoForm">
              <div class="mb-4 text-center">
                <h2 class="fs-32 fw-600 m-0 mb-2">
                  Let’s finish setting up your account
                </h2>
                <p class="fs-16 fw-400 text-secondary m-0">
                  Enter the information to customize your experience
                </p>
              </div>

              <div class="form-group mt-3 example-form">
                <div class="accordion multi-step-accordion" id="mainAccordion">
                  <!-- 1️⃣ Business Owner Information -->
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button
                        class="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="false"
                        aria-controls="collapseOne"
                      >
                        1. Business Owner Information
                      </button>
                      <span class="text-danger fs-10" *ngIf="missing1">
                        Missing information
                      </span>
                    </h2>
                    <div
                      id="collapseOne"
                      class="accordion-collapse collapse show"
                      aria-labelledby="headingOne"
                      data-bs-parent="#mainAccordion"
                      (shown.bs.collapse)="checkInfo(1, true)"
                      (hidden.bs.collapse)="checkInfo(1, false)"
                    >
                      <div class="accordion-body">
                        <div class="row">
                          <div class="col-md-6 contact-name-fields">
                            <div class="input-relative">
                              <input
                                type="text"
                                formControlName="firstName"
                                required
                                [ngClass]="{
                                  'border-danger':
                                    practiceInfoForm['controls']['firstName']
                                      .touched &&
                                    practiceInfoForm['controls']['firstName']
                                      .invalid
                                }"
                              />
                              <label class="label-name"
                                ><span class="content-name"
                                  >First Name</span
                                ></label
                              >
                            </div>
                            <p
                              class="mat-error text-danger mb-0 fs-14 validation"
                              *ngIf="
                                practiceInfoForm['controls']['firstName']
                                  .touched &&
                                practiceInfoForm['controls']['firstName']
                                  .invalid
                              "
                            >
                              Please enter your First Name.
                            </p>
                          </div>

                          <div class="col-md-6 contact-name-fields">
                            <div class="input-relative">
                              <input
                                type="text"
                                formControlName="lastName"
                                required
                                [ngClass]="{
                                  'border-danger':
                                    practiceInfoForm['controls']['lastName']
                                      .touched &&
                                    practiceInfoForm['controls']['lastName']
                                      .invalid
                                }"
                              />
                              <label class="label-name"
                                ><span class="content-name"
                                  >Last Name</span
                                ></label
                              >
                            </div>
                            <p
                              class="mat-error text-danger fs-14 validation"
                              *ngIf="
                                practiceInfoForm['controls']['lastName']
                                  .touched &&
                                practiceInfoForm['controls']['lastName'].invalid
                              "
                            >
                              Please enter your Last Name.
                            </p>
                          </div>

                          <div class="col-12 mt-3">
                            <div class="input-relative position-relative">
                              <p  *ngIf=" practiceInfoForm['controls']['doctor_mobile'].value"
                                class="position-absolute country-code"
                                style="top: 30px; left: 16px; white-space: nowrap;"

                              >
                                {{ country_data?.mobile_code || "+1" }}
                              </p>
                              <input
                              [style.padding-left]="'calc(16px + ' + (country_data?.mobile_code || '+1').length + 'ch + 4px)'"
                              type="text"
                              [mask]="mask"
                              formControlName="doctor_mobile"
                              required
                              [ngClass]="{
                                'border-danger':
                                  practiceInfoForm['controls']['doctor_mobile']
                                    .touched &&
                                  practiceInfoForm['controls']['doctor_mobile']
                                    .invalid
                              }"
                            />
                              <label class="label-name">Phone Number</label>
                            </div>
                            <p
                              class="mat-error text-danger fs-14 validation"
                              *ngIf="
                                practiceInfoForm['controls']['doctor_mobile']
                                  .touched &&
                                practiceInfoForm['controls']['doctor_mobile']
                                  .invalid
                              "
                            >
                              Please enter valid phone number.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTwo">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        2. Business Information
                      </button>

                      <span class="text-danger fs-10" *ngIf="missing2">
                        Missing information
                      </span>
                    </h2>
                    <div
                      id="collapseTwo"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingTwo"
                      data-bs-parent="#mainAccordion"
                      (shown.bs.collapse)="checkInfo(2, true)"
                      (hidden.bs.collapse)="checkInfo(2, false)"
                    >
                      <div class="accordion-body">
                        <div class="row">
                          <div class="col-12">
                            <div class="form-group input-relative">
                              <div class="input-relative">
                                <input
                                  autocomplete="new-password"
                                  type="text"
                                  name="email"
                                  required=""
                                  [ngClass]="{
                                    'border-danger':
                                      practiceInfoForm['controls'][
                                        'practice_name'
                                      ].touched &&
                                      practiceInfoForm['controls'][
                                        'practice_name'
                                      ].invalid &&
                                      !practiceInfoForm['controls'][
                                        'practice_name'
                                      ].dirty
                                  }"
                                  formControlName="practice_name"
                                  [class.value-field]="
                                    !practiceInfoForm['controls'][
                                      'practice_name'
                                    ].invalid
                                  "
                                />
                                <label for="text" class="label-name">
                                  <span class="content-name f-c-p-3 fs-14">
                                    Enter your business name
                                  </span>
                                </label>
                              </div>
                              <!-- <div class="d-flex flex-column-reverse custom-form inputContainer">
                                                            <input autocomplete="off" type="text" name="email" required=""
                                                                formControlName="practice_name" [class.value-field]="((!practiceInfoForm['controls']['practice_name'].invalid))">
                                                            <label for="text" class="label-name">
                                                                <span class="content-name f-c-p-3 fs-14"> Enter your business name
                                                                </span>
                                                            </label>
                                                        </div> -->
                              <p
                                class="mat-error mb-0 ml-0 pl-0 fs-14 text-danger validation"
                                *ngIf="
                                  practiceInfoForm['controls']['practice_name']
                                    .touched &&
                                  practiceInfoForm['controls']['practice_name']
                                    .invalid
                                "
                              >
                                Please enter your business name
                              </p>

                              <p
                                class="mat-error mb-0 ml-0 pl-0 fs-14 text-danger validation"
                                *ngIf="
                                  practiceInfoForm['controls']['practice_name']
                                    .touched &&
                                  (practiceInfoForm['controls'][
                                    'practice_name'
                                  ].hasError('whitespace') ||
                                    practiceInfoForm
                                      .get('practice_name')
                                      ?.hasError('pattern'))
                                "
                              >
                                {{
                                  practiceInfoForm["controls"][
                                    "practice_name"
                                  ].hasError("whitespace")
                                    ? "Business name cannot begin or end with a space."
                                    : " Please enter valid business name."
                                }}
                              </p>
                            </div>
                          </div>
                          <div class="col-12">
                            <div class="form-group mt-3">
                              <div class="input-relative">
                                <input
                                  autocomplete="new-password"
                                  type="text"
                                  name="email"
                                  required=""
                                  [ngClass]="{
                                    'border-danger':
                                      practiceInfoForm['controls'][
                                        'practice_email'
                                      ].touched &&
                                      practiceInfoForm['controls'][
                                        'practice_email'
                                      ].invalid &&
                                      !practiceInfoForm['controls'][
                                        'practice_email'
                                      ].dirty
                                  }"
                                  formControlName="practice_email"
                                  [class.value-field]="
                                    !practiceInfoForm['controls'][
                                      'practice_email'
                                    ].invalid
                                  "
                                />
                                <label for="text" class="label-name">
                                  <span class="content-name f-c-p-3 fs-14">
                                    Enter your business email address
                                  </span>
                                </label>
                              </div>
                              <p
                                class="mat-error mb-0 ml-0 pl-0 fs-14 text-danger validation"
                                *ngIf="
                                  practiceInfoForm['controls']['practice_email']
                                    .touched &&
                                  practiceInfoForm['controls']['practice_email']
                                    .invalid
                                "
                              >
                                Please enter valid email address.
                              </p>
                            </div>
                          </div>
                          <div class="col-12">
                            <div class="form-group mt-3 phone-input-with-code">
                              <div class="input-relative">
                                <p *ngIf="practiceInfoForm['controls'][
                                'practice_mobile'
                              ].value"
                                  class="position-absolute"
                                  style="left: 15px; top: 30px; white-space: nowrap;"
                                >
                                  {{
                                    country_data && country_data.mobile_code
                                      ? country_data.mobile_code: "+1"
                                  }}
                                </p>
                                <input
                                  [style.padding-left]="'calc(15px + ' + ((country_data && country_data.mobile_code) ? country_data.mobile_code : '+1').length + 'ch + 4px)'"
                                  [mask]="mask"
                                  autocomplete="password"
                                  (focus)="isPracticeMobileFocused = true"
                                  (blur)="isPracticeMobileFocused = false"
                                  [ngClass]="{
                                    'border-danger':
                                      practiceInfoForm['controls'][
                                        'practice_mobile'
                                      ].touched &&
                                      practiceInfoForm['controls'][
                                        'practice_mobile'
                                      ].invalid &&
                                      !practiceInfoForm['controls'][
                                        'practice_mobile'
                                      ].dirty
                                  }"
                                  type="text"
                                  name="practice_mobile"
                                  required=""
                                  formControlName="practice_mobile"
                                  [class.value-field]="
                                    !practiceInfoForm['controls'][
                                      'practice_mobile'
                                    ].invalid
                                  "
                                />
                                <label
                                  for="text"
                                  class="label-name label-phone"
                                >
                                  <span class="content-name f-c-p-3 fs-14"
                                    >Business phone number
                                  </span>
                                </label>
                              </div>

                              <p
                                class="mat-error text-danger w-100 d-block mb-0 fs-14 validation"
                                *ngIf="
                                  practiceInfoForm['controls'][
                                    'practice_mobile'
                                  ].touched &&
                                  !isPracticeMobileFocused &&
                                  practiceInfoForm['controls'][
                                    'practice_mobile'
                                  ].invalid
                                "
                              >
                                Please enter a valid Phone number
                              </p>
                            </div>
                          </div>
                          <div class="col-6">
                            <div class="input-relative form-group mt-3">
                              <div class="select-wrapper">
                                <select
                                class="input_field w-100 m-0"
                                formControlName="ind_id"
                                (change)="getSubIndustrylist()"
                                [ngClass]="{
                                  'border-danger':
                                    practiceInfoForm['controls']['ind_id'].touched &&
                                    practiceInfoForm['controls']['ind_id'].invalid &&
                                    !practiceInfoForm['controls']['ind_id'].dirty,
                              
                                  'greyLabel': !practiceInfoForm['controls']['ind_id'].value,
                                  'text-dark': practiceInfoForm['controls']['ind_id'].value
                                }"
                                [class.value-field]="!practiceInfoForm['controls']['ind_id'].invalid"
                              >
                                <option [value]="''" disabled hidden>Select Industry</option>
                              
                                <option *ngFor="let industry of industryList" [value]="industry.ind_id">
                                  {{ industry.ind_name }}
                                </option>
                              </select>                              
                                <span class="select-icon">
                                  <svg width="25" height="25" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5 7.5L10 12.5L15 7.5" stroke="#898C90" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    
                                </span>
                              </div>
                              <label *ngIf="practiceInfoForm['controls']['ind_id']?.value" for="text" class="top-label">
                                <span class="content-name f-c-p-3 fs-14">Industry </span>
                              </label>
                              <p
                                class="mat-error text-danger w-100 d-block mb-0 fs-14 validation"
                                *ngIf="
                                  (practiceInfoForm['controls']['ind_id']
                                    .touched ||
                                    practiceInfoForm['controls']['ind_id']
                                      .dirty) &&
                                  practiceInfoForm['controls']['ind_id'].invalid
                                "
                              >
                                Industry is required
                              </p>
                            </div>
                          </div>
                          <div class="col-6" *ngIf="practiceInfoForm.controls['ind_id'].value != 9999">
                            <div class="form-group mt-3 input-relative">
                              <div class="select-wrapper">
                                <select
                                  class="input_field w-100 m-0"
                                  formControlName="doctor_speciality"
                                  (change)="checkOtherVlaue($event)"
                                  [ngClass]="{
                                    'border-danger':
                                      practiceInfoForm['controls']['doctor_speciality'].touched &&
                                      practiceInfoForm['controls']['doctor_speciality'].invalid &&
                                      !practiceInfoForm['controls']['doctor_speciality'].dirty,
                                    'greyLabel': !practiceInfoForm['controls']['doctor_speciality'].value,
                                    'text-dark': !!practiceInfoForm['controls']['doctor_speciality'].value
                                  }"
                                  [class.value-field]="
                                    practiceInfoForm['controls']['doctor_speciality'].enabled &&
                                    !practiceInfoForm['controls']['doctor_speciality'].invalid
                                  "
                                >
                                  <option *ngFor="let subindustry of sub_industries"
                                    [value]="subindustry.doctor_speciality">
                                    {{ subindustry.speciality_name }}
                                  </option>
                                </select>
                              
                                <span class="select-icon">
                                  <svg width="25" height="25" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5 7.5L10 12.5L15 7.5" stroke="#898C90" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                              </div>
                              <label
                                *ngIf="!practiceInfoForm['controls']['doctor_speciality']?.value"
                                class="label-name"
                              >
                                <span class="content-name f-c-p-3 fs-14">Select Sub Industry</span>
                              </label>
                              <label *ngIf="practiceInfoForm['controls']['doctor_speciality']?.value" for="text" class="top-label">
                                <span class="content-name f-c-p-3 fs-14">Sub Industry </span>
                              </label>
                              <p
                                class="mat-error text-danger w-100 d-block mb-0 fs-14 validation"
                                *ngIf="
                                  (practiceInfoForm['controls'][
                                    'doctor_speciality'
                                  ].touched ||
                                    practiceInfoForm['controls'][
                                      'doctor_speciality'
                                    ].dirty) &&
                                  practiceInfoForm['controls'][
                                    'doctor_speciality'
                                  ].invalid
                                "
                              >
                                Sub Industry is required
                              </p>
                            </div>
                          </div>
                          <div
                            class="cols-12"
                            *ngIf="
                              practiceInfoForm.controls['ind_id'].value == 9999
                            "
                          >
                            <div class="form-group mt-3">
                              <div class="input-relative not-validator">
                                <input
                                  type="text"
                                  name="ind_name"
                                  autocomplete="none"
                                  trim="true"
                                  [ngClass]="{
                                    'border-danger':
                                      practiceInfoForm.controls['ind_name']
                                        .touched &&
                                      practiceInfoForm.controls['ind_name']
                                        .invalid &&
                                      !practiceInfoForm.controls['ind_name']
                                        .dirty
                                  }"
                                  placeholder=""
                                  formControlName="ind_name"
                                  [class.value-field]="
                                    !practiceInfoForm.controls['ind_name']
                                      .invalid
                                  "
                                />
                                <label for="text" class="label-name">
                                  <span class="content-name f-c-p-3 fs-14"
                                    >Industry Name</span
                                  >
                                </label>
                              </div>
                              <p
                                class="mat-error mb-0 ml-0 pl-0 text-danger"
                                *ngIf="
                                  practiceInfoForm.controls['ind_name'] &&
                                  practiceInfoForm.controls['ind_name']
                                    .touched &&
                                  practiceInfoForm.controls['ind_name']
                                    .invalid &&
                                  !practiceInfoForm.controls['ind_name'].dirty
                                "
                              >
                                Please enter industry name.
                              </p>
                            </div>
                          </div>

                          <div
                            class="col-12"
                            *ngIf="
                              practiceInfoForm.controls['doctor_speciality']
                                .value == 9999
                            "
                          >
                            <div class="form-group col-md-12 py-2">
                              <div class="input-relative not-validator">
                                <input
                                  type="text"
                                  name="doctor_speciality_name"
                                  [ngClass]="{
                                    'border-danger':
                                      practiceInfoForm['controls'][
                                        'doctor_speciality_name'
                                      ].touched &&
                                      practiceInfoForm['controls'][
                                        'doctor_speciality_name'
                                      ].invalid &&
                                      !practiceInfoForm['controls'][
                                        'doctor_speciality_name'
                                      ].dirty
                                  }"
                                  placeholder=""
                                  autocomplete="none"
                                  trim="true"
                                  formControlName="doctor_speciality_name"
                                  [class.value-field]="
                                    !practiceInfoForm['controls'][
                                      'doctor_speciality_name'
                                    ].invalid
                                  "
                                />
                                <label for="text" class="label-name">
                                  <span class="content-name f-c-p-3">
                                    Sub Industry Name
                                  </span>
                                </label>
                              </div>
                              <p
                                class="mat-error mb-0 ml-0 pl-0 text-danger"
                                *ngIf="
                                  practiceInfoForm.controls[
                                    'doctor_speciality_name'
                                  ] &&
                                  practiceInfoForm.controls[
                                    'doctor_speciality_name'
                                  ].touched &&
                                  practiceInfoForm.controls[
                                    'doctor_speciality_name'
                                  ].invalid &&
                                  !practiceInfoForm.controls[
                                    'doctor_speciality_name'
                                  ].dirty
                                "
                              >
                                Please enter sub industry name.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item" *ngIf="allowed_debt_type == 3">
                    <h2 class="accordion-header" id="headingThree">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        3. Type of debt to be collected
                      </button>
                      <span class="text-danger fs-10" *ngIf="missing3">
                        Missing information
                      </span>
                    </h2>

                    <div
                      id="collapseThree"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingThree"
                      data-bs-parent="#mainAccordion"
                      (shown.bs.collapse)="checkInfo(3, true)"
                      (hidden.bs.collapse)="checkInfo(3, false)"
                    >
                      <div class="accordion-body">
                        <div
                          class="debt-type-card"
                          [class.active]="
                            selectedDebtTypes.includes('consumer')
                          "
                          (click)="toggleDebtType('consumer')"
                        >
                          <div class="d-flex align-items-center">
                            <div class="icon -bg-primary-subtle me-3">
                              <img
                                class="hw-40"
                                src="assets/images/icons/consumer_icon.svg"
                                alt=""
                              />
                            </div>
                            <div>
                              <h6 class="fw-600 mb-1">Consumer Debt</h6>
                              <p class="mb-0 text-muted fs-14 mt-0">
                                Recover debt from individual customers
                              </p>
                            </div>
                          </div>
                          <div class="checkmark">
                            <img
                              *ngIf="selectedDebtTypes.includes('consumer')"
                              src="assets/images/icons/blue-tick.svg"
                              alt="Selected"
                            />
                            <img
                              *ngIf="!selectedDebtTypes.includes('consumer')"
                              src="assets/images/icons/rectangle.png"
                              alt="Unselected"
                            />
                          </div>
                        </div>
                        <div
                          class="debt-type-card"
                          [class.active]="
                            selectedDebtTypes.includes('commercial')
                          "
                          (click)="toggleDebtType('commercial')"
                        >
                          <div class="d-flex align-items-center">
                            <div class="icon -bg-success-subtle me-3">
                              <img
                                class="hw-40"
                                src="assets/images/icons/comercial_icon.svg"
                                alt=""
                              />
                            </div>
                            <div>
                              <h6 class="fw-600 mb-1">Commercial Debt</h6>
                              <p class="mb-0 text-muted fs-14 mt-0">
                                Collect outstanding invoices from businesses
                              </p>
                            </div>
                          </div>
                          <div class="checkmark">
                            <img
                              *ngIf="selectedDebtTypes.includes('commercial')"
                              src="assets/images/icons/green-tick.svg"
                              alt="Selected"
                            />
                            <img
                              *ngIf="!selectedDebtTypes.includes('commercial')"
                              src="assets/images/icons/rectangle.png"
                              alt="Unselected"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Google sign up never passes through the register screen, so the
                     Terms and Privacy Policy are reviewed here. The card opens the
                     same modal register uses and turns green once accepted. -->
                <div class="mt-3" *ngIf="google_id">
                  <button type="button" class="legal-consent w-100 d-flex align-items-center gap-3"
                    [class.accepted]="legalAccepted" (click)="showLegalModal()">
                    <span class="legal-consent-icon d-flex align-items-center justify-content-center">
                      <svg *ngIf="legalAccepted" viewBox="0 0 14 14" fill="none">
                        <path d="M2.5 7.5L5.5 10.5L11.5 3.5" stroke="currentColor" stroke-width="2"
                          stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      <svg *ngIf="!legalAccepted" viewBox="0 0 18 18" fill="none">
                        <path d="M4 2.75h6l4 4v8.5a.75.75 0 0 1-.75.75h-9.5a.75.75 0 0 1-.75-.75V3.5a.75.75 0 0 1 .75-.75Z"
                          stroke="currentColor" stroke-width="1.4" stroke-linejoin="round" />
                        <path d="M6 9.5h6M6 12h4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" />
                      </svg>
                    </span>
                    <span class="legal-consent-text fs-14">
                      <ng-container *ngIf="!legalAccepted">Review the <strong>Terms and Condition</strong> and
                        <strong>Privacy Policy</strong> to continue</ng-container>
                      <ng-container *ngIf="legalAccepted">You have accepted the <strong>Terms and Condition</strong>
                        and <strong>Privacy Policy</strong></ng-container>
                    </span>
                  </button>
                </div>

                <div class="col-12">
                  <!-- {{!checkBtn}} -->
                  <div class="text-right d-flex justify-content-end">
                    <button
                      class="btn btn-primary fw-600 mt-3"
                      [ngClass]="{ disable: !checkBtn && google_id }"
                      [class.disbale-btn]="
                        allowed_debt_type == 3 && !selectedDebtTypes.length
                      "
                      [disabled]="isContinueDisabled"
                      [attr.tabindex]="isContinueDisabled ? -1 : null"
                      type="submit"
                    >
                      Continue
                    </button>
                  </div>
                </div>
              </div>
            </ng-container>
          </form>
        </div>
        <div
          class="p-3 p-lg-0 busines-setup-otp"
          *ngIf="selectedStep === step.VERIFY_OTP"
        >
          <div class="mb-4 text-center">
            <h2 class="fs-36 fw-600 m-0 mb-3">We’ve sent you a code</h2>
            <p class="fs-16 fw-400 -text-secondary m-0">
              <span class="d-inline-block" style="max-width: 400px"
                >To complete your account setup, enter the code we have sent to
                <b>(XXX) XXX {{ last4Number }}</b>
              </span>
              <!-- <a (click)="selectedStep = step.BUSINESS_REGISTRATION" class="text-line cursor mx-2">Change</a> -->
            </p>
          </div>

          <div class="form-group mt-4 mb-3">
            <form [formGroup]="otpForm" action="" (submit)="verifyOtp()">
              <div
                class="form-group otp_fields new-otp_fields mb-3 mt-2 d-flex justify-content-between"
              >
                <input
                  id="{{ item }}"
                  (input)="onInput($event, index)"
                  (keydown.backspace)="onDelete($event, index)"
                  formControlName="{{ item }}"
                  placeholder="-"
                  type="text"
                  maxlength="1"
                  *ngFor="let item of otpValueGroup; let index = index"
                  (paste)="
                    onPasteHandler($event.clipboardData?.getData('text/plain'))
                  "
                />
              </div>
              <div>
                <p
                  class="mat-error text-danger w-100 d-block fs-14"
                  *ngIf="otpForm.hasError('credentialsMismatch')"
                >
                  {{ this.errorotp }}
                </p>
              </div>
              <div class="fs-14 mb-2" *ngIf="countdown > 0">
                Request new OTP in {{ formatTime(countdown) }} seconds
              </div>
              <p class="fs-14 fw-400 mb-2 resendcode">
                <span>Didn’t receive code?</span>
                <a *ngIf="countdown <= 0" class="cursor" (click)="renewOtp()">
                  Resend code</a
                >
              </p>

              <button class="btn btn-primary w-100 fw-600 mb-3" type="submit">
                Verify & Submit
              </button>
              <button
                class="btn btn-default w-100 fw-600"
                (click)="selectedStep = step.BUSINESS_REGISTRATION"
              >
                Back to Setup Account
              </button>
            </form>
          </div>
          <!-- <a (click)="selectedStep = step.MOBILE_NUMBER" class="text-line cursor">Change mobile number</a> -->
        </div>
      </div>
    </div>
  </div>
</div>
